<template>
  <v-combobox
    v-model="query.council"
    solo
    flat
    dense
    rounded
    :class="classes"
    :rules="[v => !!v || 'Council is required' ]"
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    hide-no-data
    hide-selected
    hide-details
    item-text="description"
    item-value="description"
    :label="label"
    return-object
    prepend-inner-icon="mdi-magnify"
    class="text-capitalize"
    @change="councilSelected"
  >
  </v-combobox>
</template>

<script>
export default {
  name: 'CouncilsAutoComplete',
  props: {
    query: {
      type: Object,
    },
    isIcon: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'mdi-magnify'
    },
    label: {
      type: String,
      default: 'Council'
    },
    classes: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      descriptionLimit: 60,
      entries: [],
      isLoading: false,
      model: '',
      search: null
    }
  },
  computed: {
    fields () {
      if (!this.model) return []

      return Object.keys(this.model).map((key) => {
        return {
          key,
          value: this.model[key] || 'n/a'
        }
      })
    },
    items () {
      return Array.from(this.entries, o => o.name.toLowerCase());
    }
  },
  watch: {
    search (val) {
      console.log('search changes')
      // Items have already been requested
      if (this.isLoading) return

      this.isLoading = true

      // Lazily load input items
      this.$store.dispatch('availabilityRegion/fetchRegions', this.search)
        .then((res) => {
          console.log(res)
          this.entries = res.data
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    }
  },
  methods: {
    councilSelected () {
      console.log('Council selected')
      this.$emit('councilSelected', this.model)
    }
  }
}
</script>

<style scoped>

</style>
